var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCovidWash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "prevent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#79ba42",
    stroke: "none",
    cx: 40,
    cy: 40,
    r: 38
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#f2ffe6",
    strokeDasharray: "4 3",
    x1: 42.56,
    y1: 25.28,
    x2: 44.83,
    y2: 33.01
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#f2ffe6",
    strokeDasharray: "4 3",
    x1: 33.74,
    y1: 25.28,
    x2: 31.47,
    y2: 33.01
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#f2ffe6",
    strokeDasharray: "4 3",
    x1: 38.28,
    y1: 25.28,
    x2: 38.28,
    y2: 33.71
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#f2ffe6",
    stroke: "none",
    points: "33.41 21.01 33.41 23.09 42.56 23.09 42.56 21.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2ffe6",
    stroke: "none",
    d: "M42.56,20H72.32a37.31,37.31,0,0,0-4.49-5.88H33.41V20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2ffe6",
    stroke: "none",
    d: "M2,41.93l16.83-.46L40,35.55a3,3,0,0,1,1.54,5.85l-2,.53H54.91a3,3,0,0,1,0,6h4a3,3,0,1,1,0,6.05h-5a3,3,0,1,1,0,6h-4a3,3,0,0,1,0,6H26.35l-7.48-1.76h-8A37.81,37.81,0,0,1,2,41.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    d: "M2,41.77v.16l16.83-.46L40,35.55a3,3,0,0,1,1.54,5.85l-2,.53H54.91a3,3,0,0,1,0,6h4a3,3,0,1,1,0,6.05h-5a3,3,0,1,1,0,6h-4a3,3,0,0,1,0,6H26.35l-7.48-1.76h-8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    d: "M53.9,60.08H33.24m25.7-6H35.25M54.91,48H35.25m4.29-6h-6.3"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#000000",
    cx: 40,
    cy: 40,
    r: 38
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovidWash);
export default __webpack_public_path__ + "static/media/covid-wash.e89d4576.svg";
export { ForwardRef as ReactComponent };